import { BranchKey } from "./types";
import { getOrInitAppStateStorage, setAppStateStorage } from "./appState";

export const setSelectedBranchKeyStorage = (key: BranchKey): BranchKey => {
	const appState = getOrInitAppStateStorage();
	setAppStateStorage({ ...appState, selectedBranchKey: key });
	return key;
};

export const getOrInitSelectedBranchKeyStorage = (): BranchKey => {
	const appState = getOrInitAppStateStorage();
	return appState.selectedBranchKey;
};